import type { SidebarNavItem } from "@app/core";
import { storeToRefs } from "pinia";
import { shallowRef, watchEffect } from "vue";
import { useRoute } from "vue-router";

import { getMenuItems } from "../modules";
import type { MenuItem } from "../types/types";

import { useAuthStore } from "@/features/auth";
import { usePartnershipStore } from "@/features/partnership";

const toNavItem = (item: MenuItem): SidebarNavItem => {
  return {
    id: item.id,
    label: item.label,
    icon: item.icon,
    badge: item.badge,
    disabled: item.disabled,
    to: item.to,
    order: item.order,
    matchNested: item.matchNested,
    activeOn: item.activeOn,
    children: item.children?.map(toNavItem),
  };
};

export const useMenu = () => {
  const route = useRoute();
  const authStore = useAuthStore();
  const partnershipStore = usePartnershipStore();

  const { partnership } = storeToRefs(partnershipStore);

  const menuItems = shallowRef<SidebarNavItem[]>([]);
  watchEffect(() => {
    const workspace = route.meta.workspace ?? "insights";
    menuItems.value = getMenuItems(authStore, partnership.value, workspace).map(toNavItem);
  });

  return { menuItems };
};
